module.exports = __webpack_public_path__ + "static/images/containers/PostbattleScreen/components/Details/images/dots.dcd1575e.png";


//////////////////
// WEBPACK FOOTER
// ./containers/PostbattleScreen/components/Details/images/dots.png
// module id = 3213
// module chunks = 11